import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import LiveTvIcon from '@material-ui/icons/LiveTv';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import HubIcon from '@material-ui/icons/DeviceHub';
import { productsData } from '../data';

const PRODUCT_ICONS = {
  'integracion-programa': LiveTvIcon,
  'agenda-semanal-alma-cartelera': EventAvailableIcon,
  'ecosistema-digital': HubIcon,
};

const Products = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Integración y alcance
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Nexus Cultural en Punto de Fe y en TNO Network
        </Box>
        <Typography variant="body1" color="textSecondary" align="center" sx={{ maxWidth: 640, mx: 'auto' }}>
          Programa y set, agenda semanal «Alma en Cartelera» (vivo + digest), TNO Digest, rotativa y SEO.
        </Typography>
      </Box>
      <Grid container spacing={4}>
        {productsData.map((item, i) => {
          const IconComponent = PRODUCT_ICONS[item.id];
          return (
            <Grid item xs={12} md={4} key={item.id}>
              <Card
                elevation={2}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  overflow: 'hidden',
                }}
                data-aos="fade-up"
                data-aos-delay={i * 80}
              >
                <CardContent sx={{ flexGrow: 1, pb: 3 }}>
                  {IconComponent && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        mb: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: 56,
                          height: 56,
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: 'primary.main',
                          boxShadow: 2,
                        }}
                      >
                        <IconComponent
                          style={{
                            fontSize: 28,
                            color: theme.palette.primary.contrastText,
                          }}
                          aria-hidden
                        />
                      </Box>
                    </Box>
                  )}
                  <Typography
                    variant="overline"
                    color="primary"
                    fontWeight={600}
                    display="block"
                    gutterBottom
                    align="center"
                  >
                    {item.product}
                  </Typography>
                  <Typography variant="h6" gutterBottom fontWeight={700} align="center">
                    {item.title}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color={theme.palette.primary.main}
                    fontWeight={700}
                    sx={{ my: 1 }}
                    align="center"
                  >
                    {item.investment}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                    Detalle:
                  </Typography>
                  <Box component="ul" sx={{ m: 0, pl: 2.5, mt: 0.5 }}>
                    {item.impacts.map((impact, j) => (
                      <Typography
                        key={j}
                        component="li"
                        variant="body2"
                        color="textSecondary"
                        sx={{ mb: 0.5 }}
                      >
                        {impact}
                      </Typography>
                    ))}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Products;
